import React, { useState, useEffect } from "react";
import { useBonus } from "../context/BonusContext";
import BonusConfirmPopup from "./BonusConfirmPopup";
import config from "../config";

const PROCESS_TYPE_MAP = {
  "yil-basi-bonus": "daily",
  "20-casino-kayip-bonusu": "weekly",
  "haftalik-5-sans-bonusu-spor": "hourly",
  "deneme-cs": "monthly",
  
  // Local demo mapping
  "demo-anlik": "hourly",
  "demo-gunluk": "daily",
  "demo-haftalik": "weekly",
  "demo-aylik": "monthly"
};

const normalizeCat = (s) => (s || "").toLowerCase()
  .replace(/ü/g, "u").replace(/ı/g, "i").replace(/ö/g, "o")
  .replace(/ğ/g, "g").replace(/ş/g, "s").replace(/ç/g, "c")
  .replace(/\s+/g, "");

const getBonusType = (cronQuery, bonusName = "", processName = "", againRequestTime = 0) => {
  if (processName && PROCESS_TYPE_MAP[processName]) {
    return PROCESS_TYPE_MAP[processName];
  }
  const nameLower = `${bonusName} ${processName}`.toLowerCase();
  if (nameLower.includes("aylık") || nameLower.includes("aylik") || nameLower.includes("monthly") || nameLower.includes("ayda")) {
    return "monthly";
  }
  if (nameLower.includes("haftalık") || nameLower.includes("haftalik") || nameLower.includes("weekly") || nameLower.includes("haftada")) {
    return "weekly";
  }
  if (nameLower.includes("günlük") || nameLower.includes("gunluk") || nameLower.includes("daily") || nameLower.includes("günde") || nameLower.includes("gunde")) {
    return "daily";
  }
  if (nameLower.includes("anlık") || nameLower.includes("anlik") || nameLower.includes("instant") || nameLower.includes("hourly") || nameLower.includes("saatlik")) {
    return "hourly";
  }

  if (againRequestTime > 0) {
    const days = againRequestTime / 86400;
    if (days > 8) return "monthly";
    if (days > 1.25) return "weekly";
    if (againRequestTime > 3 * 3600) return "daily";
    return "hourly";
  }

  if (cronQuery) {
    const parts = cronQuery.trim().split(/\s+/);
    if (parts.length >= 5) {
      const dayOfMonth = parts[2];
      const dayOfWeek = parts[4];
      if (dayOfMonth !== '*' && dayOfMonth !== '?') return "monthly";
      if (dayOfWeek !== '*' && dayOfWeek !== '?') return "weekly";
      return "daily";
    }
  }
  return "daily";
};



const DailyBonusCard = ({ bonus, onClaimClick }) => {
  const [cooldownLeft, setCooldownLeft] = useState(bonus.againRequestTime || 0);

  useEffect(() => {
    setCooldownLeft(bonus.againRequestTime || 0);
  }, [bonus.againRequestTime]);

  // Cooldown countdown timer
  useEffect(() => {
    if (!bonus.againRequestTime || bonus.againRequestTime <= 0) return;
    const timer = setInterval(() => {
      setCooldownLeft(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [bonus.againRequestTime]);

  const cDays = Math.floor(cooldownLeft / 86400);
  const cHours = Math.floor((cooldownLeft % 86400) / 3600);
  const cMinutes = Math.floor((cooldownLeft % 3600) / 60);

  return (
    <div className="new-design-card">
      <div className="new-bonus-image-container">
        {bonus.image && (
          <img src={bonus.image} alt={bonus.title} className="new-bonus-img" />
        )}
      </div>

      {cooldownLeft > 0 ? (
        <div className="new-timer-button-replacement">
          <span className="timer-part">
            <span className="num">{cDays.toString().padStart(2, '0')}</span>
            <span className="unit">GÜN</span>
          </span>
          <span className="timer-part">
            <span className="num">{cHours.toString().padStart(2, '0')}</span>
            <span className="unit">SAAT</span>
          </span>
          <span className="timer-part">
            <span className="num">{cMinutes.toString().padStart(2, '0')}</span>
            <span className="unit">DAK</span>
          </span>
        </div>
      ) : (
        <button
          className="design2-btn btn-active"
          onClick={() => onClaimClick(bonus)}
          disabled={bonus.isMaintenance}
        >
          TALEP ET
        </button>
      )}
    </div>
  );
};

const DailyBonusSection = () => {
  const { widgetBonusData, fetchBonusForUser } = useBonus();
  const [selectedBonus, setSelectedBonus] = useState(null);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  if (!widgetBonusData || widgetBonusData.length === 0) {
    return null;
  }

  const bonuses = widgetBonusData.map((talep, index) => {
    let bonusItem = null;
    if (Array.isArray(talep.data) && talep.data.length > 0) {
      bonusItem = talep.data[0];
    } else if (talep.data && typeof talep.data === 'object') {
      bonusItem = talep.data;
    }

    if (!bonusItem) return null;

    const isClaimed = Number(bonusItem.again_request_time) > 0;
    const bonusType = getBonusType(bonusItem.cron_query, bonusItem.bonus_name, bonusItem.process_name, bonusItem.again_request_time || 0);



    const getImageUrl = (path) => {
      if (!path) return null;
      if (path.startsWith('http') || path.startsWith('data:')) return path;
      const prefix = config.imgUrl && config.imgUrl.endsWith('/') ? config.imgUrl : `${config.imgUrl || ''}/`;
      const cleanedImg = path.startsWith('/') ? path.slice(1) : path;
      return `${prefix}${cleanedImg}`;
    };

    const parts = (talep.bonus_type || "").split(",").map((s) => s.trim()).filter(Boolean);
    const primaryCategory = parts.find((p) => normalizeCat(p) !== "tumu") || parts[0] || "";

    return {
      id: talep.talep_id || talep.id || bonusItem.process_name || `bonus-${index}`,
      title: (talep.bonus_name && talep.bonus_name.trim()) ? talep.bonus_name.trim() : bonusItem.bonus_name,
      process_name: bonusItem.process_name,
      rules: bonusItem.kurallar || [],
      image: getImageUrl(talep.bonus_gorsel),
      redirect_link: bonusItem.redirect_link || null,
      talep_text: bonusItem.talep_text || null,
      isMaintenance: Boolean(bonusItem.is_bakim),

      bonusType: bonusType,
      isClaimed: isClaimed,
      category: primaryCategory,
      againRequestTime: Number(bonusItem.again_request_time) || 0,
    };
  }).filter(Boolean);

  const bonusOrderMap = { hourly: 1, daily: 2, weekly: 3, monthly: 4 };
  bonuses.sort((a, b) => (bonusOrderMap[a.bonusType] || 5) - (bonusOrderMap[b.bonusType] || 5));

  if (bonuses.length === 0) {
    return null;
  }

  const handleClaimClick = (bonus) => {
    setSelectedBonus(bonus);
    setIsConfirmOpen(true);
  };

  const handleCloseConfirm = () => {
    setIsConfirmOpen(false);
    setSelectedBonus(null);
  };

  return (
    <>
      <div className="daily-bonus-wrapper">
        <div className="daily-bonus-grid">
          {bonuses.map((bonus) => (
            <DailyBonusCard
              key={bonus.id}
              bonus={bonus}
              onClaimClick={handleClaimClick}
            />
          ))}
        </div>
      </div>

      {isConfirmOpen && selectedBonus && (
        <BonusConfirmPopup
          isOpen={isConfirmOpen}
          onClose={handleCloseConfirm}
          bonus={selectedBonus}
          onConfirm={fetchBonusForUser}
        />
      )}
    </>
  );
};

export default DailyBonusSection;
